import CONSTANTS from '../../constants';

export function businessHours(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.USER.GET.BUSINESS_HOURS:
            return action.businessHours;
        default:
            return state
    }
}